
const  AdsBannerHelperOil = () => {
  return [
    {
      productId: 24568967411011,
      productRef: 25620111011,
      imageURL: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      productName: '6 BEDROOM DUPLEX',
      type: 'Buy',
      title: '6 BEDROOM DUPLEX',
      productPrice: '₦ 40,000,000',
      imgURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg`,
      imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      displayPrice: "2500 per month",
      price: 300000000,
      currency: ' ₦',
      availableUnits: 1,
      negotiable: false,
      contactNo: '08036096802',
      date_posted: '03-09-2025',
      city: 'Lagos-Island',
      state: 'Lagos',
      areaName: 'Lekki',
      category: 'Residential',
      group: 'RealEstate',
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      description: `
      Features:\n
     

      ---
      
      ✨ Key Features  
      - Fully detached 6 Bedroom Duplex with privacy  
      - Large green outdoor space + sit-out bar  
      - Superfast internet (Starlink & CSS Fiber)  
      - 24/7 power (inverter + soundproof gen)  
      - Smart TVs, ACs, Netflix, Prime  
      - PS5 & Oculus (on request)  
      - Daily cleaning + complimentary breakfast  
      - Secure estate with ample parking
      `,
    },
    {
      productId: 24568967411022,
      productRef: 25620111022,
      imageURL: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      productName: '5 BEDROOM DUPLEX',
      title: '5 BEDROOM DUPLEX',
      type: 'Buy',
      productPrice: '₦ 280,000,000',
      imgURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg`,
      imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      displayPrice: "280M",
      price: 280000000,
      currency: 'N',
      availableUnits: 1,
      negotiable: false,
      contactNo: '08036096802',
      date_posted: '03-09-2025',
      city: 'Lekki',
      state: 'Lagos',
      areaName: 'Agungi',
      category: 'Residential',
      group: 'RealEstate',
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      description: `
      Features:\n
     
      
      ---
      
      ✨ Key Features  
      - Fully detached 5 Bedroom Duplex with privacy  
      - Large green outdoor space + sit-out bar  
      - Superfast internet (Starlink & CSS Fiber)  
      - 24/7 power (inverter + soundproof gen)  
      - Smart TVs, ACs, Netflix, Prime  
      - PS5 & Oculus (on request)  
      - Daily cleaning + complimentary breakfast  
      - Secure estate with ample parking
      `,
    },
    {
      productId: 24568967411033,
      productRef: 25620111033,
      imageURL: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      productName: 'SERVICED APARTMENT',
      title: 'SERVICED APARTMENT',
      type: 'Buy',
      productPrice: "800M",
      imgURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg`,
      imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl4: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
      displayPrice: "250k per month",
      price: 800000000,
      currency: ' ₦',
      availableUnits: 1,
      negotiable: false,
      contactNo: '08036096802',
      date_posted: '03-09-2025',
      city: 'Abuja',
      state: 'FCT-Abuja',
      areaName: 'Maitama',
      category: 'Residential',
      group: 'RealEstate',
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      description: `
      Features:\n
     
          
      ---
      
      ✨ Key Features  
      - Serviced Apartment with privacy  
      - Large green outdoor space + sit-out bar  
      - Superfast internet (Starlink & CSS Fiber)  
      - 24/7 power (inverter + soundproof gen)  
      - Smart TVs, ACs, Netflix, Prime  
      - PS5 & Oculus (on request)  
      - Daily cleaning + complimentary breakfast  
      - Secure estate with ample parking
      `,
    },
    {
      productId: 24568967411044,
      productRef: 25620111044,
      imageURL: '../../images/commercial/commercial2.jpg',
      productName: 'DePlatinum High-Rise Towers',
      title: 'DePlatinum High-Rise Towers',
      type: 'Buy',
      productPrice: "₦ 1,200,000,000",
      imgURL: `../../images/commercial/commercial2.jpg`,
      imgUrl1: '../../images/commercial/commercial2.jpg',
      imgUrl2: '../../images/commercial/commercial2.jpg',
      imgUrl3: '../../images/commercial/commercial2.jpg',
      imgUrl4: '../../images/commercial/commercial2.jpg',
      imgUrl5: '../../images/commercial/commercial2.jpg',
      imgUrl6: '../../images/commercial/commercial2.jpg',
      imgUrl7: '../../images/commercial/commercial2.jpg',
      imgUrl8: '../../images/commercial/commercial2.jpg',
      imgURL9: '../../images/commercial/commercial2.jpg',
      imgUrl10: '../../images/commercial/commercial2.jpg',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
      displayPrice: "1.2B",
      price: 1200000000,
      currency: ' ₦',
      availableUnits: 1,
      negotiable: false,
      contactNo: '08036096802',
      date_posted: '03-09-2025',
      city: 'Abuja',
      state: 'FCT - Abuja',
      areaName: 'Maitaima',
      category: 'Residential',
      group: 'RealEstate',
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      description: `
      Features:\n
        
      
      ---
      
      ✨ Key Features  
      - High Rise Tower suitable for commercial activities and services  
      
      `,
    },
    {
      productId: 24568967411055,
      productRef: 25620111055,
      imageURL: '../../images/commercial/commercial1.jpg',
      productName: 'FrankHeight High-Rise Towers',
      type: 'Buy',
      title: 'FrankHeight High-Rise Towers',
      productPrice: '₦ 1,800,000,000',
      imgURL: `../../images/commercial/commercial1.jpg`,
      imgUrl1: '../../images/commercial/commercial1.jpg',
      imgUrl2: '../../images/commercial/commercial1.jpg',
      imgUrl3: '../../images/commercial/commercial1.jpg',
      imgUrl4:  '../../images/commercial/commercial1.jpg',
      imgUrl5: '../../images/commercial/commercial1.jpg',
      imgUrl6: '../../images/commercial/commercial1.jpg',
      imgUrl7: '../../images/commercial/commercial1.jpg',
      imgUrl8: '../../images/commercial/commercial1.jpg',
      imgUrl9: '../../images/commercial/commercial1.jpg',
      imgUrl10: '../../images/commercial/commercial1.jpg',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: '../../images/commercial/commercial1.jpg',
      displayPrice: "850M",
      price: 850000000,
      currency: ' ₦',
      availableUnits: 1,
      negotiable: false,
      contactNo: '08036096802',
      date_posted: '03-09-2025',
      city: 'Uyo',
      state: 'Akwa-Ibom',
      areaName: 'Shelter Afrique',
      category: 'Residential',
      group: 'RealEstate',
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      description: `
      Features:\n
      
      
      ---
      
      ✨ Key Features  
      - High Rise Tower suitable for commercial activities and services  
      `,
    },
    {
      productId: 24568967411066,
      productRef: 25620111066,
      imageURL: '../../images/commercial/commercial4.jpg',
      productName: 'Iroko High-Rise Towers',
      title: 'Iroko High-Rise Towers',
      type: 'Buy',
      productPrice: '$ 1,000,000',
      imgUrl: `../../images/commercial/commercial4.jpg`,
      imgUrl1: `../../images/commercial/commercial4.jpg`,
      imgUrl2: `../../images/commercial/commercial4.jpg`,
      imgUrl3: `../../images/commercial/commercial4.jpg`,
      imgUrl4: `../../images/commercial/commercial4.jpg`,
      imgUrl5: `../../images/commercial/commercial4.jpg`,
      imgUrl6: `../../images/commercial/commercial4.jpg`,
      imgUrl7: `../../images/commercial/commercial4.jpg`,
      imgUrl8: `../../images/commercial/commercial4.jpg`,
      imgUrl9: `../../images/commercial/commercial4.jpg`,
      imgUrl10: `../../images/commercial/commercial4.jpg`,
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
      displayPrice: "2500 per month",
      price: 1000000,
      currency: ' $',
      availableUnits: 1,
      negotiable: false,
      contactNo: '08036096802',
      date_posted: '03-09-2025',
      city: 'Uyo',
      state: 'Akwa-Ibom',
      areaName: 'Shelter Afrique',
      category: 'Residential',
      group: 'RealEstate',
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      description: `
      Features:\n
      
      
      ---
      
      ✨ Key Features  
      - High Rise Tower suitable for commercial activities and services  
      `,
    },
  ]
};


export default AdsBannerHelperOil;


// 📍 Maitama  
// 💵 ₦250K